import { Box, Grid, Typography, Hidden, IconButton, CardMedia } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/InvestorWithoutPan/contributor';
import { AmcViewer } from '../../redux-store/types/api-types';
import {
  AmcViewerAccess,
  getAmcViewerById,
  getAmcViewerAccess,
} from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import Loader from '../../utils/Loader';

export default function AmcViewerDetails({
  location,
}: {
  location: Location<{ amcViewerId: number }>;
}): JSX.Element {
  const { amcViewerId: id } = location.state || { amcViewerId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const [amcViewerDetails, setAmcViewerDetails] = useState<AmcViewer>();
  const [accessForEditAdd, setAccessForEditAdd] = useState(true);

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        // const { amcViewerAccess } = (await dispatch(
        //   getAmcViewerAccess()
        // )) as unknown as AmcViewerAccess;
        if (id) {
          const getAmcViewerDetails = (await dispatch(
            getAmcViewerById(id)
          )) as unknown as AmcViewer;
          setAmcViewerDetails(getAmcViewerDetails);
        }
        if (!isComponentActive) {
          return;
        }
        // setAccessForEditAdd(amcViewerAccess);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() => history.push('amc-viewers')}>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() => history.push('amc-viewers')}>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              AMC Viewer
            </Typography>
          </Box>
          {accessForEditAdd && (
            <IconButton>
              <CardMedia
                component="img"
                src="/images/edit-icon-outlined.svg"
                alt="Edit Icon"
                sx={{ width: 'unset' }}
                onClick={() =>
                  history.push('edit-amc-viewer', { amcViewerId: amcViewerDetails?.id })
                }
              />
            </IconButton>
          )}
        </Box>
        {isLoading ? (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'white',
              zIndex: 9999,
            }}>
            <Loader size={60} speed={2} />
          </Box>
        ) : (
          amcViewerDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'Name'} description={amcViewerDetails.user.firstName} />
                    <KeyValue title={'Email Id'} description={amcViewerDetails.user.email} />
                    <KeyValue
                      title={'Mobile Number'}
                      description={
                        amcViewerDetails.user?.countryCode
                          ? amcViewerDetails.user?.countryCode + '-' + amcViewerDetails.user?.phone
                          : amcViewerDetails.user.phone
                      }
                    />
                    <KeyValue title={'Pincode'} description={amcViewerDetails.pincode} />
                    <KeyValue title={'Building Number'} description={amcViewerDetails.buildingNo} />
                    <KeyValue title={'Street Name'} description={amcViewerDetails.streetName} />
                    <KeyValue title={'State'} description={amcViewerDetails.state} />
                    <KeyValue title={'City'} description={amcViewerDetails.city} />
                    <KeyValue title={'Country'} description={amcViewerDetails.country} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
